var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraingerProductsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef6f7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46854,
    stopColor: "#ed1e30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#ed1b2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8b1b2d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.35748,56.19312c1.07996.23285,2.18616,1.25183,2.44305,2.33405h4.62854l1.08002-6.70807h-4.07043l-.24487,1.02704c-1.25641-1.20477-3.20306-1.64221-4.93915-1.64893-6.81201-.02423-10.65033,6.15283-10.65033,11.24365,0,6.18384,4.51453,9.68896,8.64465,9.68896,3.27148,0,4.59766-1.11987,5.09137-1.77881l-.2569,1.25861h4.18781l1.80249-11.12457h-10.86707l-.64526,4.01398,5.15845.00336c-.53998,1.18719-1.81116,2.3078-3.07159,2.53937-1.62067.25641-3.35468-.26855-4.25623-1.68665-1.31012-2.11469-.69232-5.37079.69495-7.3078,1.25977-1.59711,3.28894-2.29169,5.27051-1.85419Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.66571,48.17163l16.11835-9.30554c.78961-.45587.78961-1.59552,0-2.05139l-5.6098-3.23883-18.48676,10.67346,6.79382,3.9223c.36646.21155.81793.21155,1.18439,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.48157,27.50891l-16.11823,9.30585c-.78955.45587-.78955,1.59552.00006,2.05139l5.13184,2.96283,18.48712-10.67334-6.31641-3.64673c-.36646-.21161-.81793-.21161-1.18439,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.06647,63.14972l16.18445,9.34412c.76733.44305,1.72656-.11072,1.72656-.99677v-18.68817c0-.41125-.21942-.7912-.5755-.99683l-6.87177-3.96753v9.87964l-4.19214-2.17682v-10.12317l-5.12061-2.95642c-.76733-.44305-1.72656.11072-1.72656.99683v18.68835c0,.41119.21942.7912.57556.99677Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraingerProductsScraper);
export default __webpack_public_path__ + "static/media/grainger-products-scraper.843de8c13fc5586afb3cb4d8dfcb723e.svg";
export { ForwardRef as ReactComponent };